// AR || ar => Account Receivable

export const createOffsetHistoryState = () => {
  return {
    invoice: [],
    revenue: [],
    other: [],
    payable: [],
    payAmount: 0,
  }
};

const createDialogState = () => {
  return {
    show: false,
    action: "",// view edit create
    detail: {},
  }
};

const SET_OFFSET_HISTORY = "SET_OFFSET_HISTORY";
const SET_PAYMENT_DIALOG = "SET_PAYMENT_DIALOG";
const SET_AR_DIALOG = "SET_AR_DIALOG";
const SET_NR_DIALOG = "SET_NR_DIALOG";// NR => National Receivable
const SET_BATCHPAYMENT_DIALOG = "SET_BATCHPAYMENT_DIALOG";
const SET_OFFSET_DIALOG = "SET_OFFSET_DIALOG";
const SET_CREDIT_DIALOG = "SET_CREDIT_DIALOG";

export default {
  namespaced: true,
  state: {
    // 相杀记录（打开相杀dialog时应当从这里获取信息）
    offsetHistory: createOffsetHistoryState(),

    dialogSetting: {
      // 入金登録
      payMent: {
        ...createDialogState(),
        paymentRecord: {},
      },
      accountReceivable: createDialogState(),// 売掛金 登録/詳細/編集
      nationalReceivable: createDialogState(),// 全国共通券集計 登録/詳細/編集
      // 入金明細登録
      batchPayment: {
        ...createDialogState(),
        inherentForm: {},
      },
      offset: createDialogState(),// その他相殺登録
      creditReceivable: createDialogState(),// 決済集計 登録/詳細/編集
    },
  },
  getters: {},
  mutations:{
    [SET_OFFSET_HISTORY](state, payload) {
      state.offsetHistory = { ...createOffsetHistoryState(), ...payload };
    },
    [SET_PAYMENT_DIALOG](state, payload) {
      state.dialogSetting.payMent = payload;
    },
    [SET_AR_DIALOG](state, payload) {
      state.dialogSetting.accountReceivable = payload;
    },
    [SET_NR_DIALOG](state, payload) {
      state.dialogSetting.nationalReceivable = payload;
    },
    [SET_BATCHPAYMENT_DIALOG](state, payload) {
      state.dialogSetting.batchPayment = payload;
    },
    [SET_OFFSET_DIALOG](state, payload) {
      state.dialogSetting.offset = payload;
    },
    [SET_CREDIT_DIALOG](state, payload) {
      state.dialogSetting.creditReceivable = payload;
    },
  },
  actions: {
    setOffsetHistory({ commit }, payload) {
      commit(SET_OFFSET_HISTORY, payload);
    },
    setPaymentDialog({ commit }, payload) {
      commit(SET_PAYMENT_DIALOG, payload);
    },
    setARDialog({ commit }, payload) {
      commit(SET_AR_DIALOG, payload);
    },
    setNRDialog({ commit }, payload) {
      commit(SET_NR_DIALOG, payload);
    },
    setBatchPayment({ commit }, payload) {
      commit(SET_BATCHPAYMENT_DIALOG, payload);
    },
    setOffsetDialog({ commit }, payload) {
      commit(SET_OFFSET_DIALOG, payload);
    },
    setCreditDialog({ commit }, payload) {
      commit(SET_CREDIT_DIALOG, payload);
    },
  }
};
